module.exports = __webpack_public_path__ + "img/Telepharmacy.3148d949.jpg";